import React from "react";
import Marquee from "./componentes/marquee";
import NavbarUni from "./componentes/headUni";
import Contact from "./aboutUs/contact";
import FooterPublic from "./FooterPublic";

function ContactUs() {
    return (
        <>
        <Marquee />
        <NavbarUni />
        <Contact />
        <FooterPublic />
        </>
    );
}

export default ContactUs;